module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon3.c4f7cb0e.svg";